import React, { useState, useEffect } from 'react';
import { footerAPI } from '../../services/api';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';

const FooterManager = () => {
    const [formData, setFormData] = useState({ companyName: '', description: '', socialLinks: {} });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        footerAPI.get().then(res => {
            if (res.data) setFormData(res.data);
        });
    }, []);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // client-side validation
        const validate = () => {
            if (!formData.companyName || formData.companyName.trim().length < 2) return 'Company name is required (min 2 chars)';
            if (!formData.description || formData.description.trim().length < 5) return 'Description is required (min 5 chars)';
            // optional: validate social link URLs if present
            return null;
        };
        const validationError = validate();
        if (validationError) {
            toast.error(validationError);
            setLoading(false);
            return;
        }

        try {
            await footerAPI.update(formData);
            toast.success('Footer updated successfully');
        } catch (error) {
            toast.error('Failed to update footer');
        } finally {
            setLoading(false);
        }
    };
    
    // ... handleSocialChange logic ...

    return (
        <div className="p-6">
            <Toaster />
            <h1 className="text-3xl font-bold mb-6">Footer Management</h1>
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4 max-w-2xl mx-auto">
                <input type="text" placeholder="Company Name" value={formData.companyName} onChange={(e) => setFormData({...formData, companyName: e.target.value})} className="w-full p-2 border rounded"/>
                <textarea placeholder="Description" value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} rows="4" className="w-full p-2 border rounded"/>
                {/* ... (inputs for other footer fields like contact, social links) ... */}
                <button type="submit" disabled={loading} className="px-4 py-2 bg-green-600 text-white rounded disabled:bg-gray-400">{loading ? 'Updating...' : 'Update Footer'}</button>
            </form>
        </div>
    );
};
export default FooterManager;